import {
  Alert,
  AppBar,
  Avatar,
  Box,
  CircularProgress,
  Container,
  createSvgIcon,
  CssBaseline,
  Divider,
  Icon,
  IconButton,
  Link,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Paper,
  Snackbar,
  Stack,
  Toolbar,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { ReactComponent as EasyFlow } from "../../../assets/icons/IconEasyFlow.svg";
import api from "../../../services/api";

import useStyles from "./styles";

import {
  AssignmentOutlined,
  AttachMoneyOutlined,
  BarChart,
  CableOutlined,
  ConnectWithoutContactOutlined,
  DarkModeOutlined,
  Dashboard,
  HomeOutlined,
  HubOutlined,
  InsertChartOutlined,
  LightModeOutlined,
  ListAltOutlined,
  LocalOfferOutlined,
  LockReset,
  LogoutOutlined,
  ManageAccountsOutlined,
  MenuOutlined,
  MonitorHeart,
  NotificationsActiveOutlined,
  OpenInNewOutlined,
  PermIdentityOutlined,
  PersonOutline,
  Phonelink,
  ReceiptOutlined,
  RequestQuoteOutlined,
  RouterOutlined,
  SecurityOutlined,
  SettingsOutlined,
  ShareOutlined,
  SpaceDashboard,
  SupervisorAccountOutlined,
  SupportAgentOutlined,
  TextSnippetOutlined,
  WorkspacesOutlined,
  TuneOutlined,
} from "@mui/icons-material";
import dayjs from "dayjs";
import CircularProgressWithLabel from "../../../components/circularProgressWithLabel";
import ModalEditSenhaUserLogado from "../../../components/internoModalEditSenha";
import ModalPerfil from "../../../components/internoModalPerfil";
import SideBar from "../../../components/sideBar";
import usePermissoesRotasInterno from "./usePermissoesRotasInterno";
import { temErp } from "../../../services/erpSistema";
import { telaDisponivel } from "../../../services/telasErp";

const EasyFlowIcon = createSvgIcon(<EasyFlow />);
// import { createSvgIcon } from "@mui/material/utils";

const OpticalTransceiverIcon = createSvgIcon(
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    {/* Corpo do módulo */}
    <rect
      x="4"
      y="7"
      width="14"
      height="10"
      rx="2"
      ry="2"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
    />

    {/* Porta de conexão (frente do transceptor) */}
    <rect
      x="18"
      y="10"
      width="3"
      height="4"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
    />

    {/* Detalhes internos (contatos) */}
    <line x1="6" y1="9" x2="14" y2="9" stroke="currentColor" strokeWidth="1" />
    <line
      x1="6"
      y1="15"
      x2="14"
      y2="15"
      stroke="currentColor"
      strokeWidth="1"
    />
  </svg>,
  "OpticalTransceiver",
);
function Layout(params) {
  const perfil = JSON.parse(localStorage.getItem("perfil"));
  const {
    colorMode,
    setColorMode,
    routesPermissao = {},
    admPermissao,
  } = params;

  // Permissões de rota do console interno (mesmo padrão do portal do cliente)
  const { administrador, podeVer } = usePermissoesRotasInterno({
    routesPermissao,
    admPermissao,
  });

  const [anchorEl, setAnchorEl] = useState(null);
  const [baseImage, setBaseImage] = useState(
    JSON.parse(localStorage.getItem("perfil"))?.foto || "",
  );

  const [openModalPerfil, setOpenModalPerfil] = useState(false);
  const [openModalEditSenha, setOpenModalEditSenha] = useState(false);
  const [snackbar, setSnackbar] = useState(null);
  const [windowWith, setWindowWith] = useState(window.innerWidth);

  const [clientes, setClientes] = useState([]);
  const [notificacoes, setNotificacoes] = useState([]);
  const [anchorNotificacao, setAnchorNotificacao] = useState(null);
  const openNotificacao = Boolean(anchorNotificacao);
  const theme = useTheme();
  const styles = useStyles(theme);
  const navigate = useNavigate();
  //funcoes de controle do menu
  const open = Boolean(anchorEl);

  //CONTROLLER PARA ABORT ######################################3
  const [controllerDashboard, setControllerDashboard] = useState(null);

  const [loadingCronometro, setLoadingCronometro] = useState(false);
  //################################################3

  //TEMPO SELECIONADO E FILTRO ################################################
  const [selectTime, setSelectTime] = useState(2);
  const [filterData, setFilterData] = useState({
    clienteId: "",
    interfaceId: "",
    hostId: "",
    initialDate: dayjs()
      .subtract(30, "minute")
      .set("second", 0)
      .set("millisecond", 0)
      .toDate(),
    finalDate: dayjs().set("second", 0).set("millisecond", 0).toDate(),
  });

  //################################################################

  //################################################

  //CONTADOR DE CRONOMETRO E VERIFICADOR DE FILTRO
  const [isFilter, setIsFilter] = useState(false);
  const [counter, setCounter] = useState(null);
  //#################################################33

  // drawer ##########################
  const [titlePage, setTitlePage] = useState("");
  const [openSideBar, setOpenSideBar] = useState(true);
  const [openDrawer, setOpenDrawer] = useState(false);
  const isScreenSmall = useMediaQuery(theme.breakpoints.up("lg"));
  const [openFilter, setOpenFilter] = useState(false);

  const logoDark = `${window?.config?.REACT_APP_LOGO_EXTERNO_DARK ||
    process.env.REACT_APP_LOGO_EXTERNO_DARK ||
    ""
    }`;
  //#######################################################

  useEffect(() => {
    let sidebarOpen = JSON.parse(localStorage.getItem("sidebarCollapsed"));

    if (sidebarOpen !== null) setOpenSideBar(sidebarOpen);
  }, []);

  useEffect(() => {
    if (isScreenSmall) {
      setOpenDrawer(false);
    }
  }, [isScreenSmall]);

  // Chamada de api ao carregar a página
  useEffect(() => {
    handleUsuarioId();

    const pagesDash = [
      "/interno/dash/overview",
      "/interno/dash/saude",
      "/interno/dash/disponibilidade",
      "/interno/dash/flow",
    ];

    setIsFilter(
      pagesDash?.find((page) => window.location.pathname.includes(page))
        ? true
        : false,
    );
  }, [window.location.pathname]);

  // Define imagem de perfil
  useEffect(() => {
    setBaseImage(
      localStorage.getItem("perfil") &&
        JSON.parse(localStorage.getItem("perfil")) != "undefined"
        ? JSON.parse(localStorage.getItem("perfil"))?.foto
        : "",
    );
  }, [localStorage.getItem("perfil")]);

  useEffect(() => {
    const handleResize = () => {
      setWindowWith(window.innerWidth);
    };
    handleApiGetClientes();

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const notificacoesContrato = clientes?.filter(
      (cliente) =>
        cliente?.contrato?.length > 1 || cliente?.contrato?.length === 0,
    );
    const notificacoesBlocosFlowDelete = clientes?.filter(
      (cliente) => cliente?.blocoFlowDelete?.length >= 1,
    );

    const notificacoesBlocosFlow = notificacoesBlocosFlowDelete?.map(
      (notificacoesBlocosFlow) => {
        return {
          nomeFantasia: notificacoesBlocosFlow?.nomeFantasia,
          message: `Bloco não localizado no Juniper`,
          link: `/interno/home/perfil/flow/${notificacoesBlocosFlow?.id}`,
          icon: <EasyFlowIcon fontSize="small" sx={{ marginRight: "10px" }} />,
        };
      },
    );

    const notificacoes = notificacoesContrato?.map((notificacaoContrato) => {
      if (notificacaoContrato?.contrato?.length > 1) {
        return {
          nomeFantasia: notificacaoContrato?.nomeFantasia,
          message: `Existem ${notificacaoContrato?.contrato?.length} contratos ativos`,
          link: `/interno/home/perfil/financeiro/${notificacaoContrato?.id}`,
          icon: (
            <AttachMoneyOutlined
              fontSize="small"
              sx={{ marginRight: "10px" }}
            />
          ),
        };
      } else {
        return {
          nomeFantasia: notificacaoContrato?.nomeFantasia,
          message: `Cliente não possui contrato ativo`,
          link: `/interno/home/perfil/financeiro/${notificacaoContrato?.id}`,
          icon: (
            <AttachMoneyOutlined
              fontSize="small"
              sx={{ marginRight: "10px" }}
            />
          ),
        };
      }
    });
    setNotificacoes([...notificacoes, ...notificacoesBlocosFlow]);
  }, [clientes]);

  useEffect(() => {
    if (
      filterData?.finalDate &&
      filterData?.initialDate &&
      filterData?.interfaceId &&
      filterData?.hostId &&
      filterData?.clienteId
    ) {
      const dataFilterStorage = {
        interfaceId: filterData?.interfaceId,
        clienteId: filterData?.clienteId,
        hostId: filterData?.hostId,
        selectTime: selectTime,
        initialDate: filterData?.initialDate,
        finalDate: filterData?.finalDate,
      };

      localStorage.setItem("filterData", JSON.stringify(dataFilterStorage));
    }
  }, [filterData]);

  // A verificação de ADM saiu para usePermissoesRotasInterno; aqui fica apenas
  // o fallback da foto do usuário, como no comportamento original
  const handleUsuarioId = () => {
    let result = localStorage.getItem("user");
    result = JSON.parse(result);
    // Verifica se a propriedade rlPermissoesUsuario existe e é um array
    if (Array.isArray(result?.usuario?.rlPermissoesUsuario)) {
      return false;
    }

    if (result) {
      setBaseImage(result.foto);
    } else {
      return "";
    }
  };

  async function handleApiGetClientes() {
    try {
      const response = await api.get("/interno/getClients");

      setClientes(response?.data?.filter((cliente) => cliente?.status === 0));
    } catch (error) {
      setSnackbar({
        children: "Error: Não foi possivel se conectar ao servidor",
        severity: "error",
      });
    } finally {
    }
  }

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setAnchorNotificacao(null);
  };

  const handleLogout = () => {
    localStorage.clear();
    navigate("/interno/login");
  };

  const handleCloseModalPerfil = () => {
    setOpenModalPerfil(false);
  };

  const handleDrawerToggle = () => {
    setOpenDrawer((preValue) => !preValue);
  };

  const sideBarPages = [
    podeVer("/interno/resumo") && {
      itemId: "1",
      label: "Home",
      hideTitle: true,
      link: "/interno/resumo",
      icon: <HomeOutlined />,
    },
    podeVer("/interno/home/perfil") && {
      itemId: "3",
      label: "Clientes",
      hideTitle: true,
      link: "/interno/home/perfil",
      icon: <PermIdentityOutlined />,
    },
    podeVer("/interno/dash") && {
      itemId: "2",
      label: "Dashboard",
      hideTitle: true,
      link: "/interno/dash",
      icon: <BarChart />,
      nodes: [
        podeVer("/interno/dash/overview") && {
          itemId: "2.1",
          label: "Overview",
          hideTitle: true,
          link: "/interno/dash/overview",
          icon: <Dashboard />,
        },
        podeVer("/interno/dash/saude") && {
          itemId: "2.2",
          label: "Saúde",
          hideTitle: true,
          link: "/interno/dash/saude",
          icon: <MonitorHeart />,
        },
        podeVer("/interno/dash/disponibilidade") && {
          itemId: "2.3",
          label: "Disponibilidade",
          hideTitle: true,
          link: "/interno/dash/disponibilidade",
          icon: <Phonelink />,
        },
        podeVer("/interno/dash/firewall") && {
          itemId: "2.9",
          label: "Firewall",
          hideTitle: true,
          link: "/interno/dash/firewall",
          icon: <SecurityOutlined />,
        },
        podeVer("/interno/dash/sfp") && {
          itemId: "2.4",
          label: "Transceptor óptico",
          hideTitle: true,
          link: "/interno/dash/sfp",
          icon: <OpticalTransceiverIcon />,
        },
        podeVer("/interno/dash/onu") && {
          itemId: "2.5",
          label: "ONUs",
          hideTitle: true,
          link: "/interno/dash/onu",
          icon: <RouterOutlined />,
        },
        /*   {
          itemId: "2.6",
          label: "Conexões",
          hideTitle: true,
          link: "/interno/dash/conexoes",
          icon: <CableOutlined />,
        }, */
        podeVer("/interno/dash/bgp") && {
          itemId: "2.7",
          label: "Links e Sessões",
          hideTitle: true,
          link: "/interno/dash/bgp",
          icon: <HubOutlined />,
        },
        podeVer("/interno/dash/flow") && {
          itemId: "2.8",
          label: "Flow",
          hideTitle: true,
          link: "/interno/dash/flow",
          icon: <EasyFlowIcon />,
        },
      ]?.filter(Boolean),
    },

    podeVer("/interno/relatorio") && {
      itemId: "4",
      label: "Relatórios",
      hideTitle: true,
      link: "/interno/relatorio",
      icon: <TextSnippetOutlined />,
    },
    podeVer("/interno/relatorio-reincidencia") &&
    telaDisponivel("/interno/relatorio-reincidencia") && {
      itemId: "10",
      label: "Reincidência",
      hideTitle: true,
      link: "/interno/relatorio-reincidencia",
      icon: <InsertChartOutlined />,
    },
    podeVer("/interno/suporte") && {
      itemId: "6",
      label: "Suporte",
      hideTitle: true,
      link: "/interno/suporte",
      icon: <SupportAgentOutlined />,
      nodes: [
        ...(temErp("HUBSOFT") || temErp("IXC")
          ? [
            (temErp("HUBSOFT") || temErp("IXC")) &&
            podeVer("/interno/suporte/dashAtendimentos") && {
              itemId: "6.1",
              label: "Métricas",
              hideTitle: true,
              link: "/interno/suporte/dashAtendimentos",
              icon: <SpaceDashboard />,
            },
          ]
          : []),

        // Telas só de alguns ERPs: services/telasErp
        ...(telaDisponivel("/interno/suporte/fluxoOs")
          ? [
            podeVer("/interno/suporte/fluxoOs") && {
              itemId: "6.2",
              label: "Fluxo OS",
              hideTitle: true,
              link: "/interno/suporte/fluxoOs",
              icon: <InsertChartOutlined />,
            },
          ]
          : []),
        ...(telaDisponivel("/interno/suporte/os")
          ? [
            podeVer("/interno/suporte/os") && {
              itemId: "6.3",
              label: "OS",
              hideTitle: true,
              link: "/interno/suporte/os",
              icon: <ManageAccountsOutlined />,
            },
          ]
          : []),
        podeVer("/interno/suporte/atendimentos") && {
          itemId: "6.4",
          label: "Fluxo atendimento",
          hideTitle: true,
          link: "/interno/suporte/atendimentos",
          icon: <InsertChartOutlined />,
        },
        podeVer("/interno/suporte/tickets") && {
          itemId: "6.5",
          // Com HubSoft e IXC juntos vale o padrão da HubSoft ("Tickets").
          label: temErp("IXC") && !temErp("HUBSOFT") ? "Atendimentos" : "Tickets",
          hideTitle: true,
          link: "/interno/suporte/tickets",
          icon: <LocalOfferOutlined />,
        },
        ...(telaDisponivel("/interno/suporte/workSpace")
          ? [
            podeVer("/interno/suporte/workSpace") && {
              itemId: "6.6",
              label: "Meu trabalho",
              hideTitle: true,
              link: "/interno/suporte/workSpace",
              icon: <WorkspacesOutlined />,
            },
          ]
          : []),

        /*    {
          itemId: "6.7",
          label: "Avaliação",
          hideTitle: true,
          link: "/interno/suporte/avaliacao",
          icon: <ListAltOutlined />,
        }, */
      ]?.filter(Boolean),
    },
    podeVer("/interno/financeiro") && {
      itemId: "5",
      label: "Financeiro",
      hideTitle: true,
      link: "/interno/financeiro",
      icon: <AttachMoneyOutlined />,
      nodes: [
        podeVer("/interno/financeiro/contratos") && {
          itemId: "5.1",
          label: "Contratos",
          hideTitle: true,
          link: "/interno/financeiro/contratos",
          icon: <RequestQuoteOutlined />,
        },

        podeVer("/interno/financeiro/boletos") && {
          itemId: "5.2",
          label: "Boletos",
          hideTitle: true,
          link: "/interno/financeiro/boletos",
          icon: <ReceiptOutlined />,
        },
      ]?.filter(Boolean),
    },
    podeVer("/interno/cadastroHosts") && {
      itemId: "8",
      label: "Cadastro de hosts",
      hideTitle: true,
      link: "/interno/cadastroHosts",
      icon: <RouterOutlined />,
    },

    podeVer("/interno/clientesSwap") && {
      itemId: "9",
      label: "Clientes Swap",
      hideTitle: true,
      link: "/interno/clientesSwap",
      icon: <ConnectWithoutContactOutlined />,
    },

    podeVer("/interno/centralDeAlertas") && {
      itemId: "11",
      label: "Central de Alertas",
      hideTitle: true,
      link: "/interno/centralDeAlertas",
      icon: <NotificationsActiveOutlined />,
      nodes: [
        podeVer("/interno/centralDeAlertas") && {
          itemId: "11.1",
          label: "Painel",
          hideTitle: true,
          link: "/interno/centralDeAlertas",
          icon: <MonitorHeart />,
        },
        podeVer("/interno/centralDeAlertas") && {
          itemId: "11.2",
          label: "Configuração",
          hideTitle: true,
          link: "/interno/centralDeAlertas/config",
          icon: <TuneOutlined />,
        },
      ]?.filter(Boolean),
    },

    ...(administrador
      ? [
        {
          itemId: "7",
          label: "Administração",
          hideTitle: true,
          link: "/interno/administracao",
          icon: <SupervisorAccountOutlined />,
          nodes: [
            {
              itemId: "7.1",
              label: "Usuários",
              hideTitle: true,
              link: "/interno/administracao/usuarios",
              icon: <PermIdentityOutlined />,
            },

            {
              itemId: "7.2",
              label: "Auditoria",
              hideTitle: true,
              link: "/interno/administracao/auditoria",
              icon: <AssignmentOutlined />,
            },
            {
              itemId: "7.3",
              label: "Integração ERP",
              hideTitle: true,
              link: "/interno/administracao/integracaoErp",
              icon: <ShareOutlined />,
            },
            /*      {
          itemId: "7.4",
          label: "Permissões Gerais",
          hideTitle: true,
          link: "/interno/administracao/permissoes",
          icon: <VpnKeyOutlined />,
        }, */
            {
              itemId: "7.5",
              label: "Geral",
              hideTitle: true,
              link: "/interno/administracao/geral",
              icon: <SettingsOutlined />,
            },
          ],
        },
      ]
      : []),
  ]?.filter(Boolean);
  /*   const sideBarPages = []; */
  return (
    <Box display={"flex"}>
      <CssBaseline />
      {windowWith < 1350 && (
        <AppBar
          sx={{
            background: theme.palette.gradient.sidebar,
          }}
          position="fixed"
          elevation={0}
        >
          <Container maxWidth="100vw">
            <Toolbar sx={styles.toolbar}>
              <Box sx={styles.toolbarNavigate}>
                <IconButton
                  sx={{
                    padding: "0px",
                    transform: "translateX(-20px)",
                    color: theme.palette.white.main,
                  }}
                  onClick={() => {
                    handleDrawerToggle();
                  }}
                >
                  <MenuOutlined fontSize="medium" />
                </IconButton>

                <IconButton href={"/interno/resumo"} sx={styles.IconButtonLogo}>
                  <Icon style={styles.logo}>
                    <img src={logoDark} style={styles.logo} alt="logo-home" />
                  </Icon>
                </IconButton>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  gap: 3,
                  alignItems: "center",
                }}
              >
                {loadingCronometro &&
                  (selectTime || selectTime === 0) &&
                  isFilter ? (
                  <CircularProgress sx={{ color: "primary" }} />
                ) : (counter || counter === 0) &&
                  (selectTime || selectTime === 0) &&
                  isFilter ? (
                  <CircularProgressWithLabel value={counter} />
                ) : (
                  <></>
                )}

                <Menu
                  open={openNotificacao}
                  anchorEl={anchorNotificacao}
                  placement={"bottom-end"}
                  onClose={handleClose}
                >
                  <Divider />
                  <Box sx={styles.containerMenuNotificacoes}>
                    {Array.isArray(notificacoes) &&
                      notificacoes?.map((pendente, index) => (
                        <Box>
                          <Link
                            sx={styles.linkNotificacao}
                            underline="hover"
                            href={pendente?.link}
                          >
                            <MenuItem
                              sx={styles.menuItem}
                              key={`${pendente?.id}-${index}`}
                            >
                              {pendente?.icon}

                              <Box sx={styles.containerNotificacoes}>
                                <Typography
                                  sx={styles.textClientNotificacoes}
                                  variant="caption"
                                >
                                  {pendente?.nomeFantasia}
                                </Typography>
                                <Typography variant="caption">
                                  {pendente?.message}
                                </Typography>
                              </Box>
                              <OpenInNewOutlined
                                sx={styles.iconLink}
                                fontSize="small"
                              />
                            </MenuItem>
                          </Link>
                          <Divider />
                        </Box>
                      ))}
                  </Box>
                </Menu>
              </Box>
            </Toolbar>
          </Container>
        </AppBar>
      )}
      <Box sx={{ width: "100%" }}>
        {windowWith < 1350 && <Box sx={{ height: "60px", width: "50vw" }} />}

        <Stack direction={"row"}>
          <SideBar
            defaultExpandedItems={["2", "5", "6", "7", "11"]}
            items={sideBarPages}
            title=""
            titlePage={titlePage}
            setTitlePage={setTitlePage}
            openSideBar={openSideBar}
            setOpenSideBar={setOpenSideBar}
            openDrawer={openDrawer}
            setOpenDrawer={setOpenDrawer}
            Perfil={
              <Box sx={styles.boxAvatar}>
                <Tooltip title="Abrir Opções">
                  {openSideBar || openDrawer ? (
                    <Paper
                      variant={"outlined"}
                      sx={styles.paperAvatar}
                      id="basic-button"
                      onClick={handleClick}
                    >
                      <Avatar
                        src={baseImage}
                        sx={{
                          color: theme.palette.white.main,
                          bgcolor: theme.palette.secondary.dark,
                        }}
                      />
                      <Typography noWrap sx={styles.titleAvatar}>
                        {perfil?.nome
                          ? `${perfil?.nome} ${perfil?.sobrenome}`
                          : ""}
                      </Typography>
                    </Paper>
                  ) : (
                    <IconButton onClick={handleClick}>
                      <Avatar
                        src={baseImage}
                        sx={{
                          color: theme.palette.white.main,
                          bgcolor: theme.palette.secondary.dark,
                        }}
                      />
                    </IconButton>
                  )}
                </Tooltip>

                <Menu
                  open={openNotificacao}
                  anchorEl={anchorNotificacao}
                  placement={"bottom-end"}
                  onClose={handleClose}
                >
                  <Divider />
                  <Box sx={styles.containerMenuNotificacoes}>
                    {Array.isArray(notificacoes) &&
                      notificacoes?.map((pendente, index) => (
                        <Box>
                          <Link
                            sx={styles.linkNotificacao}
                            underline="hover"
                            href={pendente?.link}
                          >
                            <MenuItem
                              sx={styles.menuItem}
                              key={`${pendente?.id}-${index}`}
                            >
                              {pendente?.icon}

                              <Box sx={styles.containerNotificacoes}>
                                <Typography
                                  sx={styles.textClientNotificacoes}
                                  variant="caption"
                                >
                                  {pendente?.nomeFantasia}
                                </Typography>
                                <Typography variant="caption">
                                  {pendente?.message}
                                </Typography>
                              </Box>
                              <OpenInNewOutlined
                                sx={styles.iconLink}
                                fontSize="small"
                              />
                            </MenuItem>
                          </Link>
                          <Divider />
                        </Box>
                      ))}
                  </Box>
                </Menu>
              </Box>
            }
          />

          <Box sx={styles.containerFilter}>
            <Box component="main" sx={styles.main}>
              <Box>
                <Outlet
                  context={{
                    controllerDashboard,
                    setControllerDashboard,
                    api,
                  }}
                />
              </Box>
            </Box>
          </Box>
        </Stack>
      </Box>

      {/* Menu de Opções */}
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
        disableScrollLock={true}
        anchorOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        sx={{
          "& .MuiPaper-root": {
            borderRadius: "10px",
            width: "200px",
            bgcolor: theme.palette.secondary.darker,
            color: theme.palette.white.main,
          },
        }}
      >
        <MenuItem //</Menu>onClick={handlePerfil}
          onClick={() => {
            setOpenModalPerfil(true);
            setAnchorEl(null);
          }}
        >
          <ListItemIcon>
            <PersonOutline sx={{ color: theme.palette.white.main }} />
          </ListItemIcon>
          <ListItemText>Perfil</ListItemText>
        </MenuItem>
        <MenuItem
          onClick={() => {
            setOpenModalEditSenha(true);
            setAnchorEl(null);
          }}
        >
          <ListItemIcon>
            <LockReset sx={{ color: theme.palette.white.main }} />
          </ListItemIcon>
          <ListItemText>Alterar Senha</ListItemText>
        </MenuItem>
        <MenuItem
          onClick={() =>
            setColorMode((prev) => {
              localStorage.setItem("darkMode", !prev);
              return !prev;
            })
          }
        >
          {colorMode ? (
            <>
              <ListItemIcon>
                <DarkModeOutlined sx={{ color: theme.palette.white.main }} />
              </ListItemIcon>
              <ListItemText>Modo Noturno</ListItemText>
            </>
          ) : (
            <>
              <ListItemIcon>
                <LightModeOutlined sx={{ color: theme.palette.white.main }} />
              </ListItemIcon>
              <ListItemText>Modo Claro</ListItemText>
            </>
          )}
        </MenuItem>

        <MenuItem onClick={handleLogout}>
          <ListItemIcon>
            <LogoutOutlined sx={{ color: theme.palette.white.main }} />
          </ListItemIcon>
          <ListItemText>Sair</ListItemText>
        </MenuItem>
      </Menu>
      <ModalPerfil
        open={openModalPerfil}
        handleClose={handleCloseModalPerfil}
      />
      <ModalEditSenhaUserLogado
        open={openModalEditSenha}
        handleClose={() => {
          setOpenModalEditSenha(false);
        }}
        setSnackbar={setSnackbar}
      />
      {!!snackbar && (
        <Snackbar
          open
          onClose={() => setSnackbar(null)}
          autoHideDuration={2500}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        >
          <Alert {...snackbar} onClose={() => setSnackbar(null)} />
        </Snackbar>
      )}
    </Box>
  );
}

export default Layout;
